interface WechatModalProps {
  open: boolean;
  onClose: () => void;
}

export default function WechatModal({ open, onClose }: WechatModalProps) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
      <div
        className="absolute inset-0 bg-espresso-900/80 backdrop-blur-sm"
        onClick={onClose}
      ></div>

      <div className="relative w-full max-w-sm bg-cream-50 rounded-lg overflow-hidden border border-gold-400/40">
        <button
          onClick={onClose}
          aria-label="关闭"
          className="cursor-pointer absolute top-3 right-3 z-10 w-9 h-9 rounded-full bg-espresso-900/10 hover:bg-espresso-900/20 flex items-center justify-center transition-colors text-espresso-900"
        >
          <i className="ri-close-line text-lg"></i>
        </button>

        <div className="px-6 pt-8 pb-6 text-center">
          <div className="inline-flex items-center gap-2 text-wine-600 text-[11px] font-serif tracking-[0.3em] uppercase">
            <span className="h-px w-6 bg-wine-500/40"></span>
            Add Advisor
            <span className="h-px w-6 bg-wine-500/40"></span>
          </div>
          <h3 className="mt-2 font-display text-2xl text-espresso-900">添加雪茄顾问</h3>
          <p className="mt-1 text-xs font-sc text-espresso-700/70">
            长按下方二维码 · 添加专属顾问微信
          </p>

          <div className="mt-6 mx-auto relative w-56 h-56 rounded-lg bg-white border border-gold-400/40 p-3 flex items-center justify-center">
            <img
              src="https://xuejia100.net/images/aocwx.png"
              alt="微信顾问二维码"
              className="w-full h-full object-contain object-top"
            />
            <span className="absolute -top-2 -left-2 w-5 h-5 border-l-2 border-t-2 border-gold-500"></span>
            <span className="absolute -top-2 -right-2 w-5 h-5 border-r-2 border-t-2 border-gold-500"></span>
            <span className="absolute -bottom-2 -left-2 w-5 h-5 border-l-2 border-b-2 border-gold-500"></span>
            <span className="absolute -bottom-2 -right-2 w-5 h-5 border-r-2 border-b-2 border-gold-500"></span>
          </div>

          <div className="mt-5 text-xs font-sc text-espresso-700/70">
            微信号 <span className="text-espresso-900 font-medium tracking-wider">Aocigar</span>
          </div>

          <div className="mt-5 grid grid-cols-3 gap-2 text-[11px] font-sc text-espresso-700/80">
            <div className="rounded-md bg-cream-100 py-2">
              <i className="ri-vip-line text-gold-500"></i>
              <div className="mt-1">会员专属</div>
            </div>
            <div className="rounded-md bg-cream-100 py-2">
              <i className="ri-truck-line text-gold-500"></i>
              <div className="mt-1">顺丰速达</div>
            </div>
            <div className="rounded-md bg-cream-100 py-2">
              <i className="ri-service-line text-gold-500"></i>
              <div className="mt-1">正品保证</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}